import React, {Component} from "react"
import {Divider, Form, Header, Icon, Input, Pagination, Segment, Table} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization} from "../../utils/localization";
import {connect} from "react-redux";
import {debounce} from "throttle-debounce";
import ConditionsWithKeyword from "./conditionsWithKeyword";
import {BREAKPOINTS, firstCharUpper, isAnsel} from "../../utils/common";
import {SupportEmailLink} from "../base";
import {CustomGrid, Responsive} from "../custom-common";
import {SearchConditionsRequest} from "../../services/types";
import {searchConditions} from "../../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData: {ratedClass, conditionListVersionSfId, riderLabels}} = state;

    return {
        ...ownProps,
        lang: user.lang,
        hasChronic: !!ratedClass.contractTerms.chronicBrokerRequested,
        hasMental: !!ratedClass.contractTerms.mentalBrokerRequested,
        conditionListVersionSfId,
        riderLabels,
    }
};

class Conditions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            resultsPerPage: 20,
            page: 1,
            totalResults: 0,
            loading: false,
            error: null,
            data: [],
            afterSearch: false
        };

        this.debounceSearch = debounce(500, this.search);
    }

    handleSearchTermChange = (event, {value}) => {
        if (value === '') {
            return this.setState({searchTerm: value, loading: false, data: [], afterSearch: false, totalResults: 0});
        }
        this.setState({searchTerm: value});
        this.debounceSearch();
    };

    search = () => {
        this.setState({page: 1}, () => this.fetchRecords());
    };

    fetchRecords = async () => {
        this.setState({error: null, loading: true});
        const {searchConditionGroup, searchTerm, page, resultsPerPage} = this.state;
        const {conditionListVersionSfId} = this.props;

        try {
            const payload = new SearchConditionsRequest({
                conditionGroupIdList: searchConditionGroup,
                searchTerm,
                page,
                resultsPerPage,
                conditionListVersionSfId
            });
            const result  = await searchConditions(payload);
            if (result.status !== 200) {
                throw Error(result.statusText);
            }
            if (this.state.searchTerm === '' || this.state.searchTerm !== searchTerm) return;
            const {totalResults, data} = result.data;
            this.setState({
                loading: false,
                data,
                totalResults,
                afterSearch: true
            })
        } catch (e) {
            console.warn(e);
            const strings = getLocalization(this.props.lang).whatsCovered;
            this.setState({loading: false, error: strings.errLoading})
        }
    };

    handlePaginationChange = (e, {activePage}) => {
        this.setState({page: activePage, loading: true}, () => this.fetchRecords());
    };

    renderMatchInText = (result, match) => {
        if (!result || result.length === 0) {
            return "";
        }

        const regex = new RegExp(match, "i");
        const parts = result.split(regex);
        let parsed = [];
        parts.forEach((p, idx)=>{
            parsed.push(p);
            if(idx+1 < parts.length){
                parsed.push(<b key={idx}>{result.substr(result.toLowerCase().indexOf(match.toLowerCase()), match.length)}</b>);
            }
        })
        return parsed;
    }

    addNotCovered = (text) => {
        const {hasChronic, hasMental, riderLabels} = this.props;
        const labels = isAnsel() ? ["Chronic", "Maintenance"] : ["Chronic"];
        if(labels.includes(text) && !hasChronic){
            return `${riderLabels.chronic}, not covered`
        } else if(text === "Mental" && !hasMental) {
            return "Mental, not covered"
        } else if (text === "Maternity") {
            return "Maternity, not covered"
        } else {
            return firstCharUpper(text);
        }
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.whatsCovered;

        const {data, page, resultsPerPage, totalResults, afterSearch, searchTerm, loading} = this.state;
        const totalPages = data.length > 0 ? Math.ceil(totalResults / resultsPerPage) : 0;

        return (
            <React.Fragment>
                <CustomGrid stackable textAlign={'center'}>
                    <CustomGrid.Row columns={1}>
                        <CustomGrid.Column width={12} textAlign={'left'}>
                            <Form>
                                <Form.Field
                                    id='searchTerms'
                                    name='searchTerms'
                                    control={Input}
                                    placeholder={strings.search}
                                    icon='search'
                                    iconPosition='left'
                                    onChange={this.handleSearchTermChange}
                                    value={this.state.searchTerm}
                                />
                            </Form>
                        </CustomGrid.Column>
                    </CustomGrid.Row>

                    {!!searchTerm && <CustomGrid.Row columns={1}>
                        <CustomGrid.Column textAlign={"left"}>
                            {afterSearch && <Header as={'h4'}><b>{strings.searchingFor} '{this.state.searchTerm}'</b></Header>}
                        </CustomGrid.Column>
                    </CustomGrid.Row>}

                    {!!loading && <CustomGrid.Column textAlign={"center"}>
                        <Divider hidden/>
                        <Segment padded={"very"} loading={loading} vertical basic/>
                    </CustomGrid.Column>}

                    {!searchTerm ? (
                        <CustomGrid.Row columns={1}>
                            <ConditionsWithKeyword/>
                        </CustomGrid.Row>
                    ) : (
                        !loading && <CustomGrid.Row columns={1}>
                            <CustomGrid.Column>
                                {data.length > 0 ? (
                                    <Table basic={'very'}>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.Cell width={7}>
                                                    <b className={'neutral700Text'}>Condition</b>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <b className={'neutral700Text'}>Category</b>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <b className={'neutral700Text'}>Keyword</b>
                                                </Table.Cell>
                                            </Table.Row>
                                            {
                                                data.map( (d, i) => {
                                                        return <Table.Row key={i}>
                                                            <Table.Cell>{this.renderMatchInText(d.conditionName, searchTerm)}</Table.Cell>
                                                            <Table.Cell>{this.renderMatchInText(this.addNotCovered(d.conditionGroupName), searchTerm)}</Table.Cell>
                                                            <Table.Cell>{this.renderMatchInText(d.keywordName, searchTerm)}</Table.Cell>
                                                        </Table.Row>
                                                    }
                                                )
                                            }
                                        </Table.Body>
                                    </Table>
                                ) : (
                                    afterSearch && <div style={{textAlign: 'center', height: 'auto'}}>
                                        <Icon name={"search"} size={"big"} color={"grey"}/>
                                        <Header as={"h4"}>{strings.cantFind}</Header>
                                        <p className={"small"}>{strings.callBrella}<br/>{strings.or}<SupportEmailLink textOverride={strings.emailOurTeam}/></p>
                                        <Divider hidden/>
                                        <Divider hidden/>
                                        <Divider hidden/>
                                    </div>
                                )}
                            </CustomGrid.Column>
                        </CustomGrid.Row>
                    )}
                </CustomGrid>

                {(!loading && data.length > 0) &&
                    <Segment basic textAlign="center">
                        <Responsive maxWidth={BREAKPOINTS.TABLET - 1}>
                            <Pagination activePage={page} onPageChange={this.handlePaginationChange}
                                        boundaryRange={0}
                                        totalPages={totalPages}/>
                        </Responsive>
                        <Responsive minWidth={BREAKPOINTS.TABLET}>
                            <Pagination activePage={page} onPageChange={this.handlePaginationChange}
                                        totalPages={totalPages}/>
                        </Responsive>
                    </Segment>
                }
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Conditions));
